import { authn } from '@xmtp/proto';
import AuthData from './AuthData';
export default class Token {
    constructor({ identityKey, authDataBytes, authDataSignature }) {
        if (!identityKey) {
            throw new Error('Missing identity key in token');
        }
        if (!authDataSignature) {
            throw new Error('Missing authDataSignature in token');
        }
        this.identityKey = identityKey;
        this.authDataBytes = authDataBytes;
        this.authDataSignature = authDataSignature;
    }
    // Get AuthData, generating from bytes and cacheing the first time it is accessed
    get authData() {
        if (!this._authData) {
            this._authData = AuthData.fromBytes(this.authDataBytes);
        }
        return this._authData;
    }
    get ageMs() {
        const now = new Date().valueOf();
        const authData = this.authData;
        const createdAt = authData.createdNs.div(1000000).toNumber();
        return now - createdAt;
    }
    toBytes() {
        return authn.Token.encode(this).finish();
    }
    static fromBytes(bytes) {
        return new Token(authn.Token.decode(bytes));
    }
    toBase64() {
        return Buffer.from(this.toBytes()).toString('base64');
    }
}
//# sourceMappingURL=Token.js.map